/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

/**
 * 安全组件
 */
import Google2FAModal from './Google2FAModal';

export { AvatarDropdown, AvatarName, Google2FAModal };
